import React from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'es7-object-polyfill';
import 'fetch-polyfill';
import 'fetch-ie8';
import 'es6-promise';
import 'isomorphic-fetch';

import { stopReportingRuntimeErrors } from "react-error-overlay";
// Service worker
import * as serviceWorker from './common/serviceWorker';

// App
import App from './App';
if (process.env.NODE_ENV === "development") {
    //stopReportingRuntimeErrors(); // disables error overlays
}
ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();
